import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import {
  AvatarContainer,
  StyledAuthorAvatar,
} from "scmp-app/components/content/content-author-image/styles";
import {
  AndSeparator,
  Authors,
  AuthorText,
  CommasSeparator,
} from "scmp-app/components/content/content-author/styles";

export const Summary = styled.div`
  color: #333333;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
`;

export const Headline = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 20px;
  line-height: 130%;
`;

export const ContentLink = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 8px;

  cursor: pointer;
`;

type AuthorsWrapperProps = {
  $isMultipleAuthors: boolean;
};

export const AuthorsWrapper = styled.div<AuthorsWrapperProps>`
  display: flex;
  gap: 12px;

  ${AvatarContainer} {
    display: flex;
    flex-direction: row;

    margin: 0;

    cursor: pointer;
    figure {
      &:not(:first-child) {
        margin-block-start: 0;
        margin-inline-start: -4px;
      }
    }
    ${StyledAuthorAvatar} {
      inline-size: 36px;
      block-size: 36px;
    }
  }

  ${Authors} {
    ${AuthorText} {
      color: #333333;
      font-weight: 700;
      font-size: 14px;
      line-height: 16px;

      cursor: pointer;
      text-decoration-line: underline;
    }
    ${AndSeparator}, ${CommasSeparator} {
      font-size: 14px;
      line-height: 16px;
    }
    ${AndSeparator} {
      margin-inline: 4px;
    }
    ${CommasSeparator} {
      margin-inline-end: 4px;
    }
  }

  ${props =>
    props.$isMultipleAuthors
      ? css`
          flex-direction: column;
          align-items: flex-start;
        `
      : css`
          flex-direction: row;
          align-items: center;
        `}
`;

export const Footer = styled.div`
  color: #888888;
  font-size: 14px;
  line-height: 16px;
`;

export const Header = styled.div`
  display: flex;
  flex-flow: column;
  gap: 8px;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  font-family: ${fontRobotoCondensed};
`;
